import { loadScript } from '@dpgradio/creative'

export default function loadMyChannelsSdk(brand) {
  loadScript(`https://embed.mychannels.video/sdk?brand=${brand}`)
}
